import { useCurrentUser } from "@/libs/apis/onboarding/useUser";
import { useCollectionData } from "@/src/hooks/useCollectionData";
import { isCollectionRevealable } from "../helpers";

const useCanCurrentUserRevealProduct = (
  collectionSlug: string,
  ownedBy: string,
) => {
  const { collectionData: collection } = useCollectionData(collectionSlug);

  const { currentUser } = useCurrentUser();

  const isOwnedByCurrentUser =
    currentUser && ownedBy === currentUser.swooshHandle;

  const collectionIsRevealable =
    collection && isCollectionRevealable(collection);

  return collectionIsRevealable && isOwnedByCurrentUser;
};

export default useCanCurrentUserRevealProduct;
